import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import backArrow from 'public/static/images/back-arrow.svg';
import { colors } from 'components/styles/variables';

interface HeaderProps {
  hasSelectedMake?: boolean;
  showMakes?: () => void;
}

const Header = forwardRef<HTMLDivElement, HeaderProps>(
  ({ hasSelectedMake, showMakes }: HeaderProps, ref): JSX.Element => {
    const { t } = useTranslation();
    return (
      <div className="header" ref={ref}>
        {hasSelectedMake ? (
          <div className="select-model-header">
            <div className="arrow" onClick={showMakes} />
            <span>{t('contentDashboard.selectAModel')}</span>
          </div>
        ) : (
          <span>{t('contentDashboard.selectMake')}</span>
        )}
        <style jsx>
          {`
            .header {
              padding: 17px 10px 10px 14px;
              border-bottom: 1px solid ${colors.G2};
              text-align: center;
              height: 60px;
              position: relative;
              font-size: 20px;
              font-weight: 600;
              color: ${colors.BLACK};
              background-color: white;
              border-radius: 5px;
              border-bottom-left-radius: 0;
              border-bottom-right-radius: 0;
              z-index: 2;
              text-transform: capitalize;
            }

            .arrow {
              background-image: url('${backArrow}');
              width: 30px;
              height: 30px;
              cursor: pointer;
            }

            .select-model-header {
              display: flex;
            }

            .select-model-header > span {
              margin: 0 auto;
              padding-right: 30px;
            }
          `}
        </style>
      </div>
    );
  }
);

export default Header;
